import appStore from 'redux/stores/app.store';
import { useGetOrderDetailById } from 'shared/hooks';
import { useOrderDetailDialogProductsSectionLang } from './useOrderDetailDialogProductsSectionLang';

import type { OrderId } from 'shared/domain';

export function useOrderDetailDialogProductsSection() {
  const { whims = [], productsByCorridor = {}, id = NaN } =
    appStore.getOrderDetailInOrderDetailDialog() ?? {};
  const orderId: OrderId = id;
  const isBeingManaged = appStore.isOrderBeingManaged(orderId) ?? false;

  const { data: order } = useGetOrderDetailById(orderId);

  const lang = useOrderDetailDialogProductsSectionLang();

  return {
    lang,
    orderId,
    substitutionFlowState: order?.substitutionFlowState,
    productsByCorridor,
    whims,
    isBeingManaged,
    isAuditable: order.isAuditable,
  };
}
